import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';

import { useParams, useHistory } from 'react-router';

import { Steps } from '../../types';
import {
  ClaimPrefix,
  OrgOnboardingStep,
  UserOnboardingStep,
} from '../../constants';
import { buildNavigationHandler, NavigationProps } from '../../util';
import { useUserOnboardingContext } from '../../contexts/UserOnboardingContext';
import { useOrgOnboardingContext } from '../../contexts/OrgOnboardingContext';
import { LoadingView } from '../common/LoadingView';
import { GetStartedView } from '../common/GetStartedView';
import CompleteProfileView from './epic-2/CompleteProfileView';

const OnboardingOrgUserClaimView = () => {
  const { orgClaimHash, getSearchParam } = useOrgOnboardingContext();
  const { isFetchingProfile, saveLocalHash, setIsUnclaimedApprover } =
    useUserOnboardingContext();
  const { userHash } = useParams<{ userHash: string }>();

  const history = useHistory();
  const pathPrefix = ClaimPrefix.ORG_USER_PROFILE;

  const navigationHandler = (
    nextStep: Steps,
    opts?: Partial<NavigationProps>,
  ) =>
    buildNavigationHandler({
      history,
      prefix: ClaimPrefix.ORG_USER_PROFILE,
      urlParams: [
        { name: 'hash', value: orgClaimHash },
        { name: 'userHash', value: userHash },
      ],
      nextStep,
      ...opts,
    });

  // Trigger profile fetching since hash has been redefined
  useEffect(() => {
    saveLocalHash(userHash);
  }, [userHash, saveLocalHash]);

  if (isFetchingProfile) {
    return <LoadingView />;
  }

  return (
    <Switch>
      <Route
        exact
        path={pathPrefix}
        render={props => (
          <GetStartedView
            type="user"
            setIsUnclaimedApprover={setIsUnclaimedApprover}
            handleGoNextStep={navigationHandler(UserOnboardingStep.PROFILE)}
            {...props}
          />
        )}
      />

      <Route
        exact
        path={`${pathPrefix}/${UserOnboardingStep.PROFILE}`}
        render={props => (
          <CompleteProfileView
            isLicensed
            handleGoNextStep={() => {
              const needsApproval = getSearchParam('approved') !== 'true';
              const nextStep = needsApproval
                ? OrgOnboardingStep.REQUEST_APPROVAL
                : UserOnboardingStep.PASSWORD;
              navigationHandler(nextStep, {
                prefix: ClaimPrefix.ORG_PROFILE,
              })();
            }}
            {...props}
          />
        )}
      />
    </Switch>
  );
};

export default OnboardingOrgUserClaimView;
